export default __webpack_public_path__ + "static/media/O-121.1ea91f24.png";